import React, { useEffect, useState } from "react";
import arrow from "../../Images/Group 1171279362.png";
import image3 from "../../Images/image 3.png";
import data from "./WinnersCitiesData";
import "./WinnersHome.css";
import HomeService from "../../Services/HomeService";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
// import { useAlert } from "react-alert";
const WinnersHomeCities = () => {
  const sliderSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 4,    // Adjust how many slides to show
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 1500,
  pauseOnHover: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: { slidesToShow: 3 },
    },
    {
      breakpoint: 600,
      settings: { slidesToShow: 2 },
    },
    {
      breakpoint: 480,
      settings: { slidesToShow: 1 },
    },
  ],
};
  // const alert = useAlert();

  const [loginProfile, setLoginProfile] = useState(null);
  const [cities, setCities] = useState([]);
  const [userId, setUserId] = useState(null);
  const [token, setToken] = useState(null);
  const [filteredProperty, setFilteredProperty] = useState([]);

  const navigate = useNavigate();

  const handleCityFilter = async (userID, ele) => {
    console.log("QWE22", ele);
    if (loginProfile === null) {
      navigate("/profile");
    }

    if (ele?.isSubscribedByUser) {
      const res = await HomeService.getFilteredPropertyList({
        userId: userID,
        cityId: ele?._id,
      });
      console.log("QWE31", res);
      if (res?.status) {
        // Pass the response data directly to navigate, instead of relying on state update
        navigate("/propertyList", { state: { filteredProperty: res.data } });
      }
    } else {
      toast.warn("You don't have a subscription for this city!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "dark",
      });

      // console.log("You don't have a subscription for this city!");
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    setToken(token);

    const getLoginProfile = async () => {
      try {
        const res = await HomeService.getLoginProfile();

        if (res?.status) {
          setLoginProfile(res?.data);
          setUserId(res?.data?._id);
          getAllCity(); // Pass userId directly
        }
        // else {
        //   getAllCityWithOutUserId();
        // }
      } catch (error) {
        console.error("Error fetching login profile:", error);
        setLoginProfile(null);
      }
    };

    getLoginProfile();
  }, [userId]); // ✅ Remove userId from dependency array

  const getAllCity = async () => {
    try {
      const res = await HomeService.getCities({ userId: userId });
      console.log("GGTR81", res.data);

      if (res) setCities(res.data);
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };

  const getAllCityWithOutUserId = async () => {
    try {
      const response = await HomeService.getAllCityList();
      console.log("SER92", response);

      if (response?.status) {
        setCities(response.data);
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };

  useEffect(() => {
    getAllCityWithOutUserId();
  }, []);
  return (
    <>
      <div
        className="search_cities_div_wrapper4"
        style={{
          marginBottom: "30px",
        }}
      >
        <div className="search_cities_div">
          <h1 className="search_cities_head">Search by Cities </h1>
          
          <div className="cities_name_container">
      <Slider {...sliderSettings}>
        {cities?.map((e, i) => (
          <div
            key={i}
            className="citites_div"
            onClick={() => {
              handleCityFilter(userId, e);
            }}
          >
            <div
              className="citites-bg"
              style={{ backgroundImage: `url("${e.image}")` }}
            ></div>
            <div className="cities_name_wrapper">
              <div className="citi_name_para_div">
                <p className="citi-name-para">{e.name}</p>
                {e.isSubscribedByUser && (
                  <img
                    className="img-class"
                    src={arrow}
                    style={{ width: "26px" }}
                    alt="arrow"
                  />
                )}
              </div>
              <p className="properties_name_para">
                {i + 2}
                {e.properities}+ Properties{" "}
              </p>
            </div>
          </div>
        ))}
      </Slider>
    </div>
          
        </div>
      </div>
    </>
  );
};

export default WinnersHomeCities;
